import { render, staticRenderFns } from "./RiskContent.vue?vue&type=template&id=2dc64a8e&scoped=true&"
import script from "./RiskContent.vue?vue&type=script&lang=js&"
export * from "./RiskContent.vue?vue&type=script&lang=js&"
import style0 from "./RiskContent.vue?vue&type=style&index=0&id=2dc64a8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc64a8e",
  null
  
)

export default component.exports